<template>
    <v-container class="toggle animated" fluid>
      <v-row>
      <v-col cols="12" md="4">
        <v-card elevation="3" color="primary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">Active Users</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="12" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ activeUsers }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card elevation="3" color="primary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">Purchases</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="12" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ totalPurchases }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card elevation="3" color="primary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">Active Products</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="12" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ activeProducts }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Dashboard',
    data(){
        return {
            totalPurchases: 0,
            activeProducts: 0,
            activeUsers: 0,
        }
    },
    methods: {
      init() {
        const token = localStorage.getItem('abughazi-admin-accesstoken')
        if (token) {
          this.loading = true
          axios.get(process.env.VUE_APP_SERVER_URL + '/api/admin/dashboard', { 
            headers: { 
                'Authorization': `Bearer ${token}`,
                'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
            }
          }).then((res)=>{
              if (res) {
                this.totalPurchases = res.data.data.purchases.all;
                this.activeUsers = res.data.data.users;
                this.activeProducts = res.data.data.products.active;
                this.loading = false
              }
          }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("abughazi-admin-accesstoken");
                            window.location.reload();
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                } 
                else if (error.request) {
                    console.log('No response received', error.request);
                } else {
                    console.log('Error', error.message);
                }
            });
        }
        else {
            localStorage.removeItem("vuex");
            localStorage.removeItem("abughazi-admin-accesstoken");
            window.location.reload();
        }
      },
    },
    mounted(){
      this.init()
    }
})

</script>

<style scoped>

</style>